import React from 'react'
import {useHistory} from 'react-router-dom'
import PropTypes from 'prop-types'
import {useTheme} from '@chakra-ui/react'
/**
 * A functional component that conditionally wraps its children with a RouteLink component.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.link - The URL to which the RouteLink should navigate. If not provided, the children are returned as-is.
 * @param {React.ReactNode} props.children - The child elements to be wrapped by the RouteLink if a link is provided.
 *
 * @returns {React.ReactNode} - The children wrapped in a RouteLink if a link is provided, otherwise the children are returned directly.
 */
export const WrapperBadgeLink = ({link, children, className}) => {
    const history = useHistory()
    const theme = useTheme()
    const baseLinkStyles = theme.components?.Link?.baseStyle || {}

    // Redirection handler for the span
    const handleSpanClick = () => {
        if (link) {
            history.push(link)
        }
    }

    return (
        <span
            className={className}
            onClick={handleSpanClick}
            role="button"
            tabIndex={0}
            {...baseLinkStyles}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    handleSpanClick(e)
                }
            }}
        >
            {children}
        </span>
    )
}

WrapperBadgeLink.propTypes = {
    link: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string
}
